import isEi from 'features/Onboarding/common/isEi';

import { VerificationHomeQueryResults } from '../useVerificationQuery/types';
import getKybDocumentStatus from './getKybDocumentStatus';
import { ContextSpecificStepStatus } from './types';

const getDraftStatutesStepStatus = (
  data: VerificationHomeQueryResults,
): ContextSpecificStepStatus => {
  if (!data?.viewer.company.isCapitalDeposit) {
    // Only Capital Deposit requires draft statutes
    return 'not-shown';
  }
  if (data?.viewer.company.isShineStart) {
    // Neither capital deposit or shine Start users have company statutes to upload
    return 'not-shown';
  }
  if (data?.viewer.company.profile?.legalForm === undefined) {
    // The legal form won't be loaded for non-primary applicant users.
    return 'not-shown';
  }
  if (isEi(data?.viewer.company.profile.legalForm)) {
    // EI users are not required to upload any company statutes.
    return 'not-shown';
  }
  const kybDocuments = data?.viewer.company.kybDocuments;
  if (!kybDocuments) {
    return 'waiting';
  }
  const statutesDoc = kybDocuments.filter(
    ({ type }) => type === 'DRAFT_STATUTES' || type === 'STATUTES', // some CD already have finalized statutes
  );
  if (statutesDoc.length === 0) {
    return 'waiting';
  }

  // Draft statutes are uploaded early in the flow, don't display them in the timeline
  // if they aren't refused nor missing
  if (
    // @ts-expect-error Object is possibly 'undefined'.
    statutesDoc[0].status !== 'REFUSED' &&
    // @ts-expect-error Object is possibly 'undefined'.
    statutesDoc[0].status !== 'MISSING'
  ) {
    return 'not-shown';
  }

  // @ts-expect-error Object is possibly 'undefined'.
  return getKybDocumentStatus(statutesDoc[0].status);
};

export default getDraftStatutesStepStatus;
